import { FC } from 'react';
import styled from 'styled-components';

interface IProps {
  percent: number;
}

const StyledProgressBar = styled.div`
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
  width: 100%;
  height: 0.5rem;
  overflow: hidden;
  margin-bottom: 2rem;
  .inner-bar {
    background-color: ${({ theme }) => theme.vars.newColor.darkGS1};
    height: 100%;
  }
`;

const ProgressBar: FC<IProps> = ({ percent }) => (
  <StyledProgressBar>
    <div className="inner-bar" style={{ width: (percent || 0) + '%' }} />
  </StyledProgressBar>
);

export default ProgressBar;
